var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-container"},[_c('UserManager',{attrs:{"modeSuper":_vm.supperAdmin,"companyUID":_vm.user_company}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }